<template>
  <div class="how-class">
    <div class="ha-des">
      <p class="black">问：如何加入班级？</p>
      <p>答：请向自己的英语老师询问自己的可瀚学堂班级码（6位数字），然后点击【我的】—【我的班级】，输入这6位班级码和真实姓名即可。</p>
    </div>
    <div class="ha-img">
      <img src="./img/class.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-class {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p{
        margin: p2r(10) 0;
      }
      a{
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title='如何加入班级? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何加入班级')
    },
    components: {}
  }
</script>
